import {
  jianye, aolaiguo, nvercun, jiangnanyewai, putuoshan,
  wuzhuangguan, xiliangnvguo, baoxiangguo, zhuziguo,
  datangjingwai, changshoucun,
  diyumigongsanceng, nvwashenji, huaguoshan, haidimigong,
  qilinshan, beijuluzhou, wanzishan, boyuedong, tiangong
} from './map.js'
import SHIMEN from '@/common/json/exp/shimen.json'
import BANGPAI from '@/common/json/exp/bangpai.json'

// 技能/修炼等级上限
// shimen / bangpai = 对应经验表长度 - 1（即满级索引）
// cultivation = 人物/召唤兽修炼等级上限；summon = 召唤兽修炼等级上限（与人物不同）
export const SKILL_MAX = {
  shimen: SHIMEN.length - 1, // 180
  bangpai: BANGPAI.length - 1, // 160
  cultivation: 31,
  summon: 20
}

// 人物可选等级档位（用于修炼、潜能果等上限查询）
export const ROLE_LEVELS = [59, 69, 89, 109, 129, 159, 175]

// 鬼怪地图分布配置：小鬼 / 大鬼出现的场景坐标（取自 map.js 导出的场景坐标）
export const GHOST_DISTRIBUTION = {
  small: [
    jianye, aolaiguo, nvercun, jiangnanyewai, putuoshan,
    wuzhuangguan, xiliangnvguo, baoxiangguo, zhuziguo,
    datangjingwai, changshoucun
  ],
  big: [
    diyumigongsanceng, nvwashenji, huaguoshan, haidimigong,
    qilinshan, beijuluzhou, wanzishan, boyuedong, tiangong
  ]
}

// 角色等级 → 修炼上限（该等级最多可点的修炼等级）
// 规则：达到修炼等级 L 需人物等级 ≥ 5L + 20，故人物等级 X 最高可点 floor((X - 20) / 5)
// 结果封顶 SKILL_MAX.cultivation
export const ROLE_CULTIVATION_MAX = Object.fromEntries(
  ROLE_LEVELS.map((lv) => [lv, Math.min(SKILL_MAX.cultivation, Math.floor((lv - 20) / 5))])
)

// 帮派技能每级「增量」成本（升到 lv 级相对 lv-1 级多花的资源）
// 数据约定：SHIMEN[i] = [累计金钱, 累计经验]，BANGPAI[i] = [累计帮贡, 累计金钱, 累计经验]
// 帮派技能的经验消耗与师门一致，因此经验增量取自 SHIMEN
export const guildSkillCost = {
  exp: (lv) => (lv >= 1 && lv < SHIMEN.length ? SHIMEN[lv][1] - SHIMEN[lv - 1][1] : 0),
  money: (lv) => (lv >= 1 && lv < BANGPAI.length ? BANGPAI[lv][1] - BANGPAI[lv - 1][1] : 0),
  contrib: (lv) => (lv >= 1 && lv < BANGPAI.length ? BANGPAI[lv][0] - BANGPAI[lv - 1][0] : 0)
}

// 帮派技能列表：数据迁移至 src/common/json/skill/shenghuo.json
// （name 已改为拼音，text 为中文名，cost 字段已删除，消耗统一用 guildSkillCost 计算）
import shenghuoSkills from '@/common/json/skill/shenghuo.json'
export const guildSkills = shenghuoSkills

// 修业点：单次最多可兑换的点数（每点消耗 50 活力）
export const STUDY_POINT_MAX_PER_TURN = 200

// 原始等级经验表 / 帮派等级经验表（供计算模块 gameCalc.js 使用）
export { SHIMEN, BANGPAI }
